// MUST be first — calls Sentry.init() at module evaluation time, before
// any subsequent import (RootLayout's transitive imports of Branch,
// RudderStack, CustomerIO, SplashScreen, Firebase, etc.) gets a chance
// to run any top-level side-effect code. Anything that throws during
// those import-time inits would otherwise escape Sentry's global error
// handler and disappear silently from observability.
import "@utils/sentry/init.side-effect";
import "@utils/disableFontScaling.side-effect";

import RootLayout, {
  ErrorBoundary as RootErrorBoundary,
} from "@components/_layout/RootLayout/index";
import { wrapExpoRouterErrorBoundary, wrapRootLayout } from "@utils/sentry";
import { deviceRuntime } from "../runtime/root";
import { RuntimeProvider } from "../runtime/provider";
import { AuthBoundary } from "../runtime/AuthBoundary";

export const ErrorBoundary = wrapExpoRouterErrorBoundary((props) => (
  <RuntimeProvider runtime={deviceRuntime}>
    <RootErrorBoundary {...props} />
  </RuntimeProvider>
));

function RuntimeRootLayout() {
  return (
    <RuntimeProvider runtime={deviceRuntime}>
      <AuthBoundary>
        <RootLayout />
      </AuthBoundary>
    </RuntimeProvider>
  );
}

export default wrapRootLayout(RuntimeRootLayout);
